module.exports = __webpack_public_path__ + "static/media/HomeHeroDashboard.ad530ac7.png";